import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOption = function (id) {
    return useApiCall(function (signal, id) { return api.option.apiOptionDataIdGet(id, { signal: signal }); }, {}, !!id, [id]);
};
